/* Reflect native variant, quantity and form state; never create a second cart request. */
(() => {
  const init = () => document.querySelectorAll('[data-j-buy-bar]').forEach(bar => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const section = bar.dataset.section;
    const shell = document.getElementById(`ProductSection-${section}`) || document.querySelector('[data-product-shell]');
    const form = document.getElementById(`product-form-${section}`);
    const buy = shell?.querySelector('#r-pdp-buy');
    const sourcePrice = document.getElementById(`price-${section}`);
    if (!shell || !form || !buy || !sourcePrice) return;
    // Move the existing native quantity control next to its form, retaining all IDs,
    // events, optional packaging and the explicit form association.
    const actions = buy.querySelector('[data-purchase-actions]');
    const nativeQuantity = shell.querySelector('.product-form__quantity');
    if (actions && nativeQuantity) {
      actions.prepend(nativeQuantity);
      actions.classList.add('has-quantity');
    }
    const price = bar.querySelector('[data-r-sticky-price]');
    const selection = bar.querySelector('[data-j-sticky-selection]');
    const choice = bar.querySelector('[data-j-sticky-choice]');
    const add = bar.querySelector('[data-j-sticky-add]');
    const nativeButton = () => form.querySelector('button[name="add"]');
    // Read the native variant and quantity; this is a price explanation, not a purchase control.
    let variants = [];
    try { variants = JSON.parse(bar.querySelector('[data-j-purchase-variants]')?.textContent || '[]'); } catch (_) { /* Native price remains the fallback. */ }
    const currency = bar.dataset.currency;
    const money = currency ? new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency }) : null;
    let recap = null;
    if (actions && bar.dataset.directBuy === 'true' && variants.length && money) {
      recap = document.createElement('div');
      recap.className = 'j-purchase-selection';
      recap.hidden = true;
      recap.setAttribute('role', 'status');
      recap.setAttribute('aria-live', 'polite');
      recap.innerHTML = '<span><small>Deine Auswahl</small><strong data-j-selection-label></strong></span><span><small>Zwischensumme</small><strong data-j-selection-total></strong></span>';
      actions.before(recap);
    }
    let stickyRequest = false;
    // Content (price, selection, subtotal) only changes with variant/quantity/form state;
    // position (sticky visibility) changes on scroll. Keep them apart so scrolling never
    // rebuilds the price, and write to the DOM only when a value actually changes.
    const mobileQuery = matchMedia('(max-width:749px)');
    const infoWrapper = shell.querySelector('.product__info-wrapper');
    const serviceShell = shell.matches('.r-pdp-shell--service,.r-pdp-shell--voucher');
    let lastVisible = null;
    let lastHeight = -1;
    const setHeight = () => {
      const height = bar.hidden ? 0 : bar.offsetHeight;
      if (height !== lastHeight) {
        lastHeight = height;
        document.body.style.setProperty('--r-sticky-buy-h', `${height}px`);
      }
    };
    if ('ResizeObserver' in window) new ResizeObserver(() => { if (!bar.hidden) setHeight(); }).observe(bar);
    const content = () => {
      const button = nativeButton();
      const error = buy.querySelector('.r-product-form-status.is-error:not([hidden])');
      if (stickyRequest && error) {
        stickyRequest = false;
        error.setAttribute('tabindex', '-1');
        error.scrollIntoView({ block: 'center' });
        error.focus({ preventScroll: true });
      }
      const priceHidden = sourcePrice.classList.contains('visibility-hidden');
      if (price.hidden !== priceHidden) price.hidden = priceHidden;
      const source = sourcePrice.querySelector('.price');
      if (source) {
        const clone = source.cloneNode(true);
        clone.querySelectorAll('.visually-hidden,[class*="badge"]').forEach(el => el.remove());
        if (price.innerHTML !== clone.outerHTML) price.innerHTML = clone.outerHTML;
      }
      const picker = shell.querySelector('variant-radios,variant-selects');
      const values = picker ? [...picker.querySelectorAll('input[type="radio"]:checked,select')].map(el => el.value) : [];
      const quantity = document.querySelector(`input[name="quantity"][form="product-form-${section}"]`);
      const label = [...values, ...(Number(quantity?.value) > 1 ? [`Menge ${quantity.value}`] : [])].join(' · ');
      if (selection.textContent !== label) selection.textContent = label;
      const count = Number(quantity?.value);
      const variant = variants.find(v => String(v.id) === form.querySelector('input[name="id"]')?.value);
      const showRecap = !!recap && !!variant && Number.isInteger(count) && count > 1 && !button?.disabled;
      if (recap) {
        if (recap.hidden === showRecap) recap.hidden = !showRecap;
        if (showRecap) {
          const description = variant.title === 'Default Title' ? `${count} Stück` : `${count} × ${variant.title}`;
          const total = money.format(variant.price * count / 100);
          const recapLabel = recap.querySelector('[data-j-selection-label]');
          const recapTotal = recap.querySelector('[data-j-selection-total]');
          if (recapLabel.textContent !== description) recapLabel.textContent = description;
          if (recapTotal.textContent !== total) recapTotal.textContent = total;
          // The sticky amount now represents the selected quantity, with a clear subtotal label.
          const markup = `<span class="j-sticky-subtotal">${total}<small>Zwischensumme</small></span>`;
          if (price.innerHTML !== markup) price.innerHTML = markup;
        }
      }
    };
    const position = () => {
      const button = nativeButton();
      // Read layout first, then write.
      const rect = (button || buy).getBoundingClientRect();
      const past = rect.bottom <= 0;
      const mobile = mobileQuery.matches;
      const before = mobile && rect.top >= innerHeight && (infoWrapper?.getBoundingClientRect().top ?? 0) < 100;
      const hidden = !(past || (mobile && before));
      if (bar.hidden !== hidden) bar.hidden = hidden;
      const direct = past && bar.dataset.directBuy === 'true' && !!button && !serviceShell;
      if (choice.hidden !== direct) choice.hidden = direct;
      if (add.hidden !== !direct) add.hidden = !direct;
      const disabled = !button || button.disabled || button.classList.contains('loading');
      if (add.disabled !== disabled) add.disabled = disabled;
      const text = button?.classList.contains('loading') ? 'Wird hinzugefügt …' : button?.disabled ? 'Nicht verfügbar' : 'In den Warenkorb';
      if (add.textContent !== text) add.textContent = text;
      if (lastVisible !== !bar.hidden) {
        lastVisible = !bar.hidden;
        document.body.classList.toggle('has-r-sticky-buy', lastVisible);
        setHeight();
      }
    };
    const sync = () => { content(); position(); };
    let queued = false;
    let needContent = false;
    const run = () => { queued = false; if (needContent) { needContent = false; content(); } position(); };
    const schedule = () => { needContent = true; if (!queued) { queued = true; requestAnimationFrame(run); } };
    const schedulePosition = () => { if (!queued) { queued = true; requestAnimationFrame(run); } };
    add.addEventListener('click', () => {
      const button = nativeButton();
      if (!button || button.disabled || button.classList.contains('loading') || add.disabled) return;
      stickyRequest = true;
      button.click();
      sync();
    });
    new MutationObserver(schedule).observe(sourcePrice, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    new MutationObserver(schedule).observe(buy, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class', 'hidden'] });
    shell.addEventListener('change', schedule);
    shell.addEventListener('input', schedule);
    addEventListener('scroll', schedulePosition, { passive: true });
    addEventListener('resize', schedule);
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
